import { action } from 'satcheljs';

export interface OptionalConnectedExperiencesStatusUpdate {
    isOceDisabled: boolean;
}

export const optionalConnectedExperiencesStatusChanged: (
    update: OptionalConnectedExperiencesStatusUpdate
) => {
    update: OptionalConnectedExperiencesStatusUpdate;
} = action('optionalConnectedExperiencesStatusChanged', update => ({
    update,
}));
